export const FROZEN_COLUMN_COUNT = 4;

export const getFrozenColumnCount = (headers, key) => {
  const visible = (headers || []).filter((header) => header?.visible !== false);
  const index = visible.findIndex((header) => header?.key === key);
  return index >= 0 ? index + 1 : 0;
};

export const getStickyColumnOffsets = (widths) => {
  const offsets = [];
  let sum = 0;
  (widths || []).forEach((width) => {
    offsets.push(sum);
    const value = Number(width);
    sum += Number.isFinite(value) && value > 0 ? value : 0;
  });
  return offsets;
};

export const getStickyColumnStyleVars = (offsets, prefix) => {
  const vars = {};
  (offsets || []).forEach((offset, index) => {
    vars[`${prefix}${index + 1}`] = `${offset}px`;
  });
  return vars;
};

export const applyStickyColumnOffsets = (scroller, count) => {
  if (!scroller || typeof scroller.querySelectorAll !== "function") return;
  const cells = scroller.querySelectorAll("thead tr:first-child th");
  const widths = [];
  for (let index = 0; index < count; index += 1) {
    const cell = cells[index];
    widths.push(cell && cell.getBoundingClientRect ? cell.getBoundingClientRect().width : 0);
  }
  const vars = getStickyColumnStyleVars(getStickyColumnOffsets(widths), "--ol-sticky-left-");
  Object.entries(vars).forEach(([name, value]) => {
    scroller.style.setProperty(name, value);
  });
};
